import {Injectable} from '@angular/core';
import {ShoppingBasket} from '../../model/sofy/shopping-basket/shopping-basket';
import {Cached, CacheKey} from '@ngx-cache/core';
import {Product} from '../../model/sofy/shopping-basket/product';
import {SalesOffer} from '../../model/sofy/sales-offer/sales-offer';
import {HttpClient} from '@angular/common/http';
import {CacheConstants} from '../../shared/cache-constants';
import {Environment} from '../../shared/environment/environment';
import {Observable} from 'rxjs';
import {OmapiIdsUtils} from '../../shared/utils/omapi-ids/omapi-ids-utils';

@Injectable()
export class SofyService {

  constructor(private httpClient: HttpClient) {
  }

  @Cached(CacheConstants.SALES_OFFER)
  public getSalesOffer(@CacheKey omapiId: string, @CacheKey dtvIdentifier: string, @CacheKey customerProductHolding: any,
                       promotions: any, address: any): Observable<SalesOffer> {
    const product: Product = {
      identifier: dtvIdentifier,
      address: address,
      installationaddress: address,
      omapiid: omapiId
    };
    const shoppingBasket: ShoppingBasket = {
      products: [product],
      customerproductholding: customerProductHolding.customerproductholding,
      promotions: promotions.promotions
    };

    if (OmapiIdsUtils.salesOfferDate) {
      shoppingBasket.salesofferdate = OmapiIdsUtils.salesOfferDate;
    }

    return this.httpClient.post<SalesOffer>(this.sofyBaseUrl(), shoppingBasket);
  }

  private sofyBaseUrl(): string {
    return Environment.environmentConfig().sofyApiUrl;
  }
}
